import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          sidebar: {
            DefaultChannel: 'Default Channel',
            CurrentLottery: 'Current Lottery',
            Overview: 'Overview',
            Users: 'Users',
            Lotteries: 'Lotteries',
            Prizes: 'Prizes',
            History: 'History',
            ParticipationHistory: 'Participation History',
            Settings: 'Settings',
            NotificationSettings: 'Notification Settings',
            SystemSettings: 'System Settings',
            redeem: 'Redeem',
            Locations: 'Locations',
            media: 'Media',
            Campaigns: 'Campaigns',
            Leads: 'Leads',
            LeadsLists: 'Lead Lists',
            Dashboard: 'Dashboard',
            Customer: 'Customer',
            Lottery: 'Lottery',
            Management: 'Management',
            PrivacyPolicy: 'Privacy Policy'
          },
          lottery: {
            createLottery: 'Create Lottery',
            editDefaultLottery: 'Edit Default Lottery',
            createDefaultLottery: 'Create Default Lottery',
            noDefaultLottery: 'No default lottery available.',
            default: 'Default',
            name: 'Name',
            startDate: 'Start Date',
            endDate: 'End Date',
            active: 'Active',
            closed: 'Closed',
            prizes: 'Prizes',
            editTitle: 'Edit Lottery',
            deleteTitle: 'Delete Lottery',
            deleteConfirm: 'Are you sure you want to delete this lottery?',
            activationThreshold: 'Activation Threshold',
            prizeSelectLabel: 'Select prizes',
            noPrizesSelected: 'No prizes selected yet.',
            amountLabel: 'Amount',
            activeLotteries: 'Active Lotteries',
            visibleToChildren: 'Visible to Children'
          },
          field: {
            Name: 'Name',
            Description: 'Description',
            StartDate: 'Start Date',
            EndDate: 'End Date',
          },
          general: {
            Add: 'Add',
            Create: 'Create',
            Remove: 'Remove',
            Cancel: 'Cancel',
            Save: 'Save',
            Yes: 'Yes',
            No: 'No',
            Edit: 'Edit',
            Delete: 'Delete',
            Apply: 'Apply',
            Loading: 'Loading...',
            Join: 'Join now',
            Signin: 'Sign in',
            Username: 'Username',
            Password: 'Password',
            View: 'View',
            Share: 'Share',
            CopyLink: 'Copy link',
            Close: 'Close',
            Actions: 'Actions'
          },
          roles: {
            admin: 'Admin',
            employee: 'Employee',
            user: 'User'
          },
          users: {
            empty: 'No accounts found.',
            deleteConfirm: 'Delete account "{{username}}"?',
            passwordHint: 'Leave blank to keep current password',
            dialog: {
              createTitle: 'Create Account',
              updateTitle: 'Update Account'
            },
            fields: {
              firstName: 'First Name',
              lastName: 'Last Name',
              email: 'Email',
              userType: 'User Type'
            },
            userType: {
              admin: 'ADMIN',
              employee: 'EMPLOYEE'
            },
            errors: {
              usernameEmailRequired: 'Username and email are required.',
              passwordRequired: 'Password is required for new accounts.',
              saveFailed: 'Failed to save account',
              deleteFailed: 'Failed to delete account'
            },
            success: {
              created: 'Account created successfully.',
              updated: 'Account updated successfully.',
              deleted: 'Account deleted successfully.'
            }
          },
          redeem: {
            title: 'Redeem Prize',
            luckyNumber: 'Lucky Number',
            checking: 'Checking...',
            redeemButton: 'Redeem',
            errorDefault: 'Redeem failed.',
            errorServer: 'Server error.',
            success: 'Prize redeem successful!',
            winner: 'Winner',
            prize: 'Prize',
            noPrize: 'No prize info',
            popupTitle: 'Congratulations! You won:'
          },
          media: {
            title: 'Media Management',
            logo: 'Logo',
            selectLogo: 'Select Logo',
            createLogo: 'Create Logo',
            updateLogo: 'Update Logo',
            deleteLogo: 'Delete Logo',
            selectNewLogo: 'Select New Logo',
            saveChanges: 'Save Changes',
            uploadImage: 'Upload Image',
            saveMedia: 'Save Media',
            savedImages: 'Saved Images',
            editMedia: 'Edit Media',
            changeImage: 'Change Image'
          },
          locations: {
            title: 'Locations Management',
            name: 'Name',
            link: 'Review Link',
            actions: 'Actions',
            edit: 'Edit',
            delete: 'Delete',
            nameLabel: 'Location Name',
            linkLabel: 'Review Link',
            create: 'Create Location',
            createSuccess: 'Location created successfully!',
            error: 'An error occurred.',
            all: 'All Locations',
            editTitle: 'Edit Location',
            deleteTitle: 'Delete Location',
            deleteConfirm: 'Are you sure you want to delete this location?'
          },
          prizes: {
            title: 'Prize Management',
            name: 'Name',
            description: 'Description',
            image: 'Image',
            create: 'Create Prize',
            edit: 'Edit',
            delete: 'Delete',
            actions: 'Actions',
            nameLabel: 'Prize Name',
            descriptionLabel: 'Prize Description',
            imageLabel: 'Prize Image',
            createSuccess: 'Prize created successfully!',
            editTitle: 'Edit Prize',
            deleteTitle: 'Delete Prize',
            deleteConfirm: 'Are you sure you want to delete this prize?',
            error: 'An error occurred.',
            all: 'All Prizes',
            update: 'Update Prize',
            saveChanges: 'Save Changes'
          },
          participation: {
            date: 'Participation Date',
            luckyNumber: 'Lucky Number',
            name: 'Name',
            phone: 'Phone',
            email: 'Email',
            location: 'Location',
            win: 'Win',
            prizes: 'Prize',
            lottery: 'Lottery',
            loading: 'Loading...',
            redeemed: 'Redeemed'
          },
          campaigns: {
            title: "Send Email Campaign",
            subject: "Subject",
            body: "Body",
            send: "Send",
            sendSuccess: "Campaign sent successfully!",
            sendError: "Failed to send campaign.",
            locationSelect: "Select Locations",
            locations: "Locations",
            selectAllLocations: "Select All",
            selectLocationError: "Please select at least one location.",
            leadLists: "Lead Lists",
            selectAllLeadLists: "Select All Lead Lists",
            selectRecipientsError: "Please select at least one recipient."
          },
          legal: {
            title: 'Legal Manager',
            create: 'Create',
            edit: 'Edit Item',
            update: 'Update',
            cancel: 'Cancel',
            fillAll: 'Please fill title, category and content.',
            titleCol: 'Title',
            categoryCol: 'Category',
            contentCol: 'Content',
            actions: 'Actions',
            createSuccess: 'Item created.',
            updateSuccess: 'Item updated.',
            deleteSuccess: 'Item deleted.'
          },
          errors: {
            loginFailed: 'Login failed. Please check your credentials.'
          },
          title: {
            Accounts: 'Accounts'
          }
        }
      },
      de: {
        translation: {
          sidebar: {
            DefaultChannel: 'Standard-Kanal',
            CurrentLottery: 'Aktuelles Gewinnspiel',
            Overview: 'Übersicht',
            Users: 'Benutzer',
            Lotteries: 'Gewinnspiele',
            Prizes: 'Gewinne',
            History: 'Historie',
            ParticipationHistory: 'Teilnahme Historie',
            Settings: 'Einstellungen',
            NotificationSettings: 'Nachricht Einstellungen',
            SystemSettings: 'System Einstellungen',
            redeem: 'Einlösen',
            Locations: 'Standorte',
            media: 'Medien',
            Campaigns: 'Kampagnen',
            Leads: 'Leads',
            LeadsLists: 'Lead-Listen',
            Dashboard: 'Dashboard',
            Customer: 'Kunde',
            Lottery: 'Gewinnspiel',
            Management: 'Verwaltung',
            PrivacyPolicy: 'Datenschutz'
          },
          lottery: {
            createLottery: 'Gewinnspiel erstellen',
            editDefaultLottery: 'Standard-Gewinnspiel bearbeiten',
            createDefaultLottery: 'Standard-Gewinnspiel erstellen',
            noDefaultLottery: 'Kein Standard-Gewinnspiel verfügbar.',
            default: 'Standard',
            name: 'Name',
            startDate: 'Startdatum',
            endDate: 'Enddatum',
            active: 'Aktiv',
            closed: 'Geschlossen',
            prizes: 'Gewinne',
            editTitle: 'Gewinnspiel bearbeiten',
            deleteTitle: 'Gewinnspiel löschen',
            deleteConfirm: 'Möchten Sie dieses Gewinnspiel wirklich löschen?',
            activationThreshold: 'Aktivierungsschwelle',
            prizeSelectLabel: 'Gewinne auswählen',
            noPrizesSelected: 'Noch keine Gewinne ausgewählt.',
            amountLabel: 'Anzahl',
            activeLotteries: 'Aktive Gewinnspiele',
            visibleToChildren: 'Für Kinder sichtbar'
          },
          field: {
            Name: 'Name',
            Description: 'Beschreibung',
            StartDate: 'Start Datum',
            EndDate: 'End Datum',
          },
          general: {
            Add: 'Hinzufügen',
            Create: 'Erstellen',
            Remove: 'Entfernen',
            Cancel: 'Abbrechen',
            Save: 'Speichern',
            Yes: 'Ja',
            No: 'Nein',
            Edit: 'Bearbeiten',
            Delete: 'Löschen',
            Apply: 'Anwenden',
            Loading: 'Wird geladen...',
            Join: 'Jetzt mitmachen',
            Signin: 'Anmelden',
            Username: 'Benutzername',
            Password: 'Passwort',
            View: 'Ansehen',
            Share: 'Teilen',
            CopyLink: 'Link kopieren',
            Close: 'Schließen',
            Actions: 'Aktionen'
          },
          roles: {
            admin: 'Administrator',
            employee: 'Mitarbeiter',
            user: 'Benutzer'
          },
          users: {
            empty: 'Keine Konten gefunden.',
            deleteConfirm: 'Konto "{{username}}" löschen?',
            passwordHint: 'Leer lassen, um das aktuelle Passwort zu behalten',
            dialog: {
              createTitle: 'Konto erstellen',
              updateTitle: 'Konto aktualisieren'
            },
            fields: {
              firstName: 'Vorname',
              lastName: 'Nachname',
              email: 'E-Mail',
              userType: 'Benutzertyp'
            },
            userType: {
              admin: 'ADMIN',
              employee: 'EMPLOYEE'
            },
            errors: {
              usernameEmailRequired: 'Benutzername und E-Mail sind erforderlich.',
              passwordRequired: 'Passwort ist für neue Konten erforderlich.',
              saveFailed: 'Konto konnte nicht gespeichert werden',
              deleteFailed: 'Konto konnte nicht gelöscht werden'
            },
            success: {
              created: 'Konto erfolgreich erstellt.',
              updated: 'Konto erfolgreich aktualisiert.',
              deleted: 'Konto erfolgreich gelöscht.'
            }
          },
          redeem: {
            title: 'Preis einlösen',
            luckyNumber: 'Glücksnummer',
            checking: 'Überprüfe...',
            redeemButton: 'Einlösen',
            errorDefault: 'Einlösen fehlgeschlagen.',
            errorServer: 'Serverfehler.',
            success: 'Preis erfolgreich eingelöst!',
            winner: 'Gewinner',
            prize: 'Preis',
            noPrize: 'Keine Preisinformation',
            popupTitle: 'Herzlichen Glückwunsch! Sie haben gewonnen:'
          },
          media: {
            title: 'Medienverwaltung',
            logo: 'Logo',
            selectLogo: 'Logo auswählen',
            createLogo: 'Logo erstellen',
            updateLogo: 'Logo aktualisieren',
            deleteLogo: 'Logo löschen',
            selectNewLogo: 'Neues Logo auswählen',
            saveChanges: 'Änderungen speichern',
            uploadImage: 'Bild Auswählen',
            saveMedia: 'Hochladen und Speichern',
            savedImages: 'Gespeicherte Bilder',
            editMedia: 'Bild bearbeiten',
            changeImage: 'Bild ändern'
          },
          locations: {
            title: 'Standortverwaltung',
            name: 'Name',
            link: 'Bewertungslink',
            actions: 'Aktionen',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            nameLabel: 'Standortname',
            linkLabel: 'Bewertungslink',
            create: 'Standort erstellen',
            createSuccess: 'Standort erfolgreich erstellt!',
            error: 'Ein Fehler ist aufgetreten.',
            all: 'Alle Standorte',
            editTitle: 'Standort bearbeiten',
            deleteTitle: 'Standort löschen',
            deleteConfirm: 'Möchten Sie diesen Standort wirklich löschen?'
          },
          prizes: {
            title: 'Gewinnverwaltung',
            name: 'Name',
            description: 'Beschreibung',
            image: 'Bild',
            create: 'Gewinn erstellen',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            actions: 'Aktionen',
            nameLabel: 'Gewinnname',
            descriptionLabel: 'Gewinnbeschreibung',
            imageLabel: 'Gewinnbild',
            createSuccess: 'Gewinn erfolgreich erstellt!',
            editTitle: 'Gewinn bearbeiten',
            deleteTitle: 'Gewinn löschen',
            deleteConfirm: 'Möchten Sie diesen Gewinn wirklich löschen?',
            error: 'Ein Fehler ist aufgetreten.',
            all: 'Alle Gewinne',
            update: 'Gewinn aktualisieren',
            saveChanges: 'Änderungen speichern'
          },
          participation: {
            date: 'Teilnahmedatum',
            luckyNumber: 'Glücksnummer',
            name: 'Name',
            phone: 'Telefon',
            email: 'E-Mail',
            location: 'Standort',
            win: 'Gewonnen',
            prizes: 'Preis',
            lottery: 'Gewinnspiel',
            loading: 'Lädt...',
            redeemed: 'Eingelöst'
          },
          campaigns: {
            title: "E-Mail-Kampagne versenden",
            subject: "Betreff",
            body: "Inhalt",
            send: "Senden",
            sendSuccess: "Kampagne erfolgreich versendet!",
            sendError: "Fehler beim Versenden der Kampagne.",
            locationSelect: "Standorte auswählen",
            locations: "Standorte",
            selectAllLocations: "Alle auswählen",
            selectLocationError: "Bitte wählen Sie mindestens einen Standort aus.",
            leadLists: "Lead-Listen",
            selectAllLeadLists: "Alle Lead-Listen auswählen",
            selectRecipientsError: "Bitte wählen Sie mindestens einen Empfänger aus."
          },
          legal: {
            title: 'Rechtsverwaltung',
            create: 'Erstellen',
            edit: 'Bearbeiten',
            update: 'Aktualisieren',
            cancel: 'Abbrechen',
            fillAll: 'Bitte Titel, Kategorie und Inhalt ausfüllen.',
            titleCol: 'Titel',
            categoryCol: 'Kategorie',
            contentCol: 'Inhalt',
            actions: 'Aktionen',
            createSuccess: 'Eintrag erstellt.',
            updateSuccess: 'Eintrag aktualisiert.',
            deleteSuccess: 'Eintrag gelöscht.'
          },
          errors: {
            loginFailed: 'Anmeldung fehlgeschlagen. Bitte Zugangsdaten prüfen.'
          },
          title: {
            Accounts: 'Konten'
          }
        }
      }
    }
  });

export default i18n;
